import { useDepartmentFeatureBlocksQuery } from '@/composables/featureBlocks.js'
import { useAuth } from '@/composables/useAuth.js'
export function useFeatureBlocks() {
  const { activeDepartment } = useAuth()

  const departmentId = computed(() => activeDepartment.value?.id)

  const query = useDepartmentFeatureBlocksQuery(departmentId)

  const featureBlocks = computed(() => query.data?.data ?? [])

  const visibleFeatureBlocks = computed(() =>
    featureBlocks.value
      .filter((block) => block.attributes?.visible && block.attributes?.name)
      .map((block) => block.attributes!.name),
  )

  return {
    featureBlocks,
    visibleFeatureBlocks,
  }
}
